import { useState, useEffect } from 'react';

const useIsTouchDevice = (): boolean => {
	const [isTouchDevice, setIsTouchDevice] = useState(false);

	useEffect(() => {
		const mql = window.matchMedia('(pointer: coarse)');
		setIsTouchDevice(mql.matches);

		const handleChange = (e: MediaQueryListEvent) => {
			setIsTouchDevice(e.matches);
		};

		mql.addEventListener('change', handleChange);

		return () => {
			mql.removeEventListener('change', handleChange);
		};
	}, []);

	return isTouchDevice;
};

export default useIsTouchDevice;
